import React from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

/**
 * Renders a page header with a title and an optional description.
 *
 * @param {string} props.title - The main title to display in the header.
 * @param {string} [props.description] - An optional description displayed below the title.
 * @returns {JSX.Element} The rendered page header component.
 */
export function PageHeader({ title, description, children }: PageHeaderProps) {
  return (
    <div className="mb-4 justify-between sm:flex sm:flex-row sm:items-center">
      <div className="mb-4 sm:mb-0">
        <h1 className="text-xl font-semibold text-gray-900">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-sm text-gray-700">
            {description}
          </p>
        )}
      </div>
      {children && children}
    </div>
  );
}